import { Text, Section } from '@acast/decibel';
import T from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Episode, MediaFile, Show } from 'resources';
import EmbedCodeGenerator from 'shared/components/embed-code-generator';
import Container from 'shared/components/content-container';
import ShareDialog from 'shared/components/share-episode-dialog';
import resourceProp, {
  episodePropType,
  mediaFilePropType,
  showPropType,
} from 'shared/helpers/resource-prop';
import { markerPropType } from '../../../customPropTypes';
import { getEpisodeStatus } from '../../../ducks/episodes';
import { selectMarkers } from '../../../ducks/markers';
import Audiogram from './audiogram';
import EpisodeDetails from './episode-details';
import PublishSettings from './publish-settings';

export class PublishSettingsView extends Component {
  renderShareSection() {
    const { show, episode } = this.props;
    const { pending, data } = episode;

    if (!pending && data && (data.isPublished || data.isQueued)) {
      return (
        <Section>
          <ShareDialog show={show.data} episode={data} />
        </Section>
      );
    }
    return null;
  }

  render() {
    const { show, episode, markers, mediaFile } = this.props;

    if (episode.pending || show.pending) {
      return null;
    }

    const episodeDuration = mediaFile && mediaFile.data && mediaFile.data.duration;

    return (
      <Container>
        <EpisodeDetails showId={episode.data.show} />

        <PublishSettings
          episode={episode}
          episodeDuration={episodeDuration}
          markers={markers}
          showId={episode.data.show}
        />

        {getEpisodeStatus(episode.data) === 'Published' && (
          <Audiogram
            data-test-id="episode-page__publish-settings__audiogram"
            episode={episode}
            episodeDuration={episodeDuration}
          />
        )}

        {this.renderShareSection()}

        <Section>
          <Text variant="h3">Embed Player</Text>
          <EmbedCodeGenerator
            showSlug={show.data.permalinks[0]}
            episodeSlug={episode.data.permalinks[0]}
          />
        </Section>
      </Container>
    );
  }
}

PublishSettingsView.propTypes = {
  show: showPropType,
  episode: episodePropType,
  markers: T.arrayOf(markerPropType),
  mediaFile: mediaFilePropType,
};

PublishSettingsView.defaultProps = {
  markers: [],
};

const WrappedPublishSettingsView = connect((state, { params }) => ({
  markers: selectMarkers(state, params.episodeId),
}))(PublishSettingsView);

const PublishSettingsContainer = (props, context) => (
  <WrappedPublishSettingsView {...context} {...props} />
);

PublishSettingsContainer.contextTypes = {
  show: resourceProp(Show),
  episode: resourceProp(Episode),
  mediaFile: resourceProp(MediaFile),
};

export default PublishSettingsContainer;
